<template>
  <ul>
    <!-- SPECIAL CASE: SuperAdmin without active company
         -> show only 5 flat items as main menu -->
    <template v-if="isSuperAdminWithoutCompany">
      <li class="menu-title">
        <span>Main Menu</span>
      </li>
      <li>
        <ul>
          <li
            v-for="menu in superAdminRootMenus"
            :key="menu.menuValue"
            :class="{ active: isMenuActive(menu) }"
          >
            <router-link :to="menu.route">
              <i :class="'ti ti-' + (menu.icon || 'user-star')"></i>
              <span>{{ menu.menuValue }}</span>
            </router-link>
          </li>
        </ul>
      </li>
    </template>

    <!-- NORMAL CASE: company selected (SuperAdmin or normal user) -->
    <template v-else>
      <template v-for="item in sideBarData" :key="item.tittle">
        <!-- hide whole section if nothing visible inside (super admin visibility only) -->
        <template v-if="shouldShowSection(item)">
          <li class="menu-title" v-if="item.tittle">
            <span>{{ item.tittle }}</span>
          </li>
          <li>
            <ul>
              <template v-for="menu in item.menu" :key="menu.menuValue">
                <template v-if="shouldShowMenu(menu)">
                  <!-- Simple item (no submenu) -->
                  <li
                    v-if="!menu.hasSubRoute && !menu.hasSubRouteTwo"
                    :class="{
                      active: isMenuActive(menu),
                      'menu-locked': isMenuLocked(menu),
                    }"
                    :title="isMenuLocked(menu) ? lockMessageForMenu(menu) : ''"
                  >
                      <router-link
                      v-if="menu.route"
                      :to="isMenuLocked(menu) ? $route.fullPath : menu.route"
                      @click.prevent="
                        isMenuLocked(menu) &&
                          onLockedClick(lockMessageForMenu(menu), menu.menuValue)
                      "
                    >
                      <i :class="'ti ti-' + (menu.icon || 'dot')"></i>
                      <span>{{ menu.menuValue }}</span>
                    </router-link>
                  </li>

                  <!-- One-level submenu -->
                  <li
                    v-else-if="menu.hasSubRoute && !menu.hasSubRouteTwo"
                    class="submenu"
                  >
                    <a
                      href="javascript:void(0);"
                      @click="expandSubMenus(menu)"
                      :class="{
                        subdrop: menu.showSubRoute && !openMenuItem,
                        active: isActive(menu),
                        'menu-locked': isMenuLocked(menu),
                      }"
                      :title="
                        isMenuLocked(menu) ? lockMessageForMenu(menu) : ''
                      "
                    >
                      <i :class="'ti ti-' + menu.icon"></i>
                      <span>{{ menu.menuValue }}</span>
                      <span
                        v-if="menu.currentActive"
                        class="badge badge-danger fs-10 fw-medium text-white p-1"
                      >
                        Hot
                      </span>
                      <span class="menu-arrow"></span>
                    </a>
                    <ul :class="menu.showSubRoute ? 'd-block' : 'd-none'">
                      <template
                        v-for="(subMenu, index) in menu.subMenus"
                        :key="index"
                      >
                        <li
                          v-if="shouldShowSub(menu, subMenu)"
                          :class="{
                            'menu-locked': isSubMenuLocked(menu, subMenu),
                          }"
                          :title="
                            isSubMenuLocked(menu, subMenu)
                              ? lockMessageForSub(menu, subMenu)
                              : ''
                          "
                        >
                          <router-link
                            :to="
                              isSubMenuLocked(menu, subMenu)
                                ? $route.fullPath
                                : subMenu.route
                            "
                            @click.prevent="
                              isSubMenuLocked(menu, subMenu) &&
                                onLockedClick(
                                  lockMessageForSub(menu, subMenu),
                                  subMenu.menuValue
                                )
                            "
                          >
                            {{ subMenu.menuValue }}
                          </router-link>
                        </li>
                      </template>
                    </ul>
                  </li>

                  <!-- Two-level submenu -->
                  <li v-else-if="menu.hasSubRouteTwo" class="submenu">
                    <a
                      href="javascript:void(0);"
                      @click="OpenMenu(menu)"
                      :class="{
                        subdrop: openMenuItem === menu || isActive(menu),
                        active: isActive(menu),
                        'menu-locked': isMenuLocked(menu),
                      }"
                      :title="
                        isMenuLocked(menu) ? lockMessageForMenu(menu) : ''
                      "
                    >
                      <i :class="'ti ti-' + menu.icon"></i>
                      <span>{{ menu.menuValue }}</span>
                      <span class="menu-arrow"></span>
                    </a>
                    <ul
                      :class="{
                        'd-block': openMenuItem === menu,
                        'd-none': openMenuItem !== menu,
                      }"
                    >
                      <template
                        v-for="subMenus in menu.subMenus"
                        :key="subMenus.menuValue"
                      >
                        <li v-if="shouldShowSub(menu, subMenus)">
                          <!-- normal second level -->
                          <template v-if="!subMenus.customSubmenuTwo">
                            <router-link
                              :to="
                                isSubMenuLocked(menu, subMenus)
                                  ? $route.fullPath
                                  : subMenus.route
                              "
                              router-link-active="active"
                              :class="{
                                'menu-locked': isSubMenuLocked(menu, subMenus),
                              }"
                              :title="
                                isSubMenuLocked(menu, subMenus)
                                  ? lockMessageForSub(menu, subMenus)
                                  : ''
                              "
                              @click.prevent="
                                isSubMenuLocked(menu, subMenus) &&
                                  onLockedClick(
                                    lockMessageForSub(menu, subMenus),
                                    subMenus.menuValue
                                  )
                              "
                            >
                              {{ subMenus.menuValue }}
                            </router-link>
                          </template>

                          <!-- third-level submenu -->
                          <template v-else>
                            <li
                              class="submenu submenu-two"
                              :class="{
                                'menu-locked': isSubMenuLocked(menu, subMenus),
                              }"
                              :title="
                                isSubMenuLocked(menu, subMenus)
                                  ? lockMessageForSub(menu, subMenus)
                                  : ''
                              "
                            >
                              <a
                                href="javascript:void(0);"
                                @click="openSubmenuOne(subMenus)"
                                :class="{
                                  subdrop:
                                    openSubmenuOneItem === subMenus ||
                                    isSubActive(subMenus),
                                  active: isSubActive(subMenus),
                                }"
                              >
                                {{ subMenus.menuValue }}
                                <span class="menu-arrow inside-submenu"></span>
                              </a>
                              <ul
                                :class="{
                                  'd-block': openSubmenuOneItem === subMenus,
                                  'd-none': openSubmenuOneItem !== subMenus,
                                }"
                              >
                                <template
                                  v-for="subMenuTwo in subMenus.subMenusTwo"
                                  :key="subMenuTwo.menuValue"
                                >
                                  <li
                                    v-if="
                                      shouldShowSubTwo(
                                        menu,
                                        subMenus,
                                        subMenuTwo
                                      )
                                    "
                                    :class="{
                                      'menu-locked': isSubMenuLocked(
                                        menu,
                                        subMenuTwo
                                      ),
                                    }"
                                    :title="
                                      isSubMenuLocked(menu, subMenuTwo)
                                        ? lockMessageForSub(menu, subMenuTwo)
                                        : ''
                                    "
                                  >
                                    <router-link
                                      :to="
                                        isSubMenuLocked(menu, subMenuTwo)
                                          ? $route.fullPath
                                          : subMenuTwo.route
                                      "
                                      @click.prevent="
                                        isSubMenuLocked(menu, subMenuTwo) &&
                                          onLockedClick(
                                            lockMessageForSub(menu, subMenuTwo),
                                            subMenuTwo.menuValue
                                          )
                                      "
                                    >
                                      {{ subMenuTwo.menuValue }}
                                    </router-link>
                                  </li>
                                </template>
                              </ul>
                            </li>
                          </template>
                        </li>
                      </template>
                    </ul>
                  </li>
                </template>
              </template>
            </ul>
          </li>
        </template>
      </template>
    </template>
  </ul>

  <Teleport to="body">
    <div
      class="modal fade"
      id="plan_upgrade_modal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow-lg">
          <div class="modal-body p-4 p-md-5">
            <div class="small text-uppercase fw-semibold text-muted mb-2">
              Plan Access
            </div>
            <h3 class="mb-2">{{ lockedModalTitle }}</h3>
            <p class="text-muted mb-4">
              {{ lockedModalMessage }}
            </p>

            <div class="rounded-4 border bg-light p-3 mb-4">
              <div class="small text-muted">Current Plan</div>
              <div class="fw-semibold">
                {{ accessStore.planName || "No active plan" }}
              </div>
            </div>

            <div class="d-flex gap-2 flex-wrap">
              <template v-if="lockedModalContext === 'billing'">
                <button
                  type="button"
                  class="btn btn-dark"
                  @click="navigateToBilling"
                >
                  Upgrade Plan
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  @click="navigateToBilling"
                >
                  Open Billing
                </button>
              </template>
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import sideBarData from "@/assets/json/sidebar-data.json";
import * as bootstrap from "bootstrap";
import { useAuthStore } from "@/stores/authStore";
import { useAccessStore } from "@/stores/accessStore";
import { getActiveCompanyId } from "@/services/_headers.util";
import { isTenancyFrontendEnabled, isTenantHost } from "@/utils/hostname";
import {
  canShowCrmMenuForEmployee,
  isCrmMenuValue,
} from "@/utils/crmAccess";
import {
  canShowFinanceAccountingMenuForEmployee,
  canShowFinanceSalesMenuForEmployee,
  isFinanceAccountingMenuValue,
  isFinanceSalesMenuValue,
} from "@/utils/financeAccess";
import {
  canShowAdminAssetsMenuForEmployee,
  canShowAdminReportsMenuForEmployee,
  canShowAdminSettingsMenuForEmployee,
  isAdminAssetsMenuValue,
  isAdminReportsMenuValue,
  isAdminSettingsMenuValue,
} from "@/utils/adminAccess";
import {
  canShowHrmAttendanceMenuForEmployee,
  canShowHrmAttendanceMenuForPureEmployee,
  canShowHrmEmployeeMenuForEmployee,
  canShowHrmPayrollMenuForEmployee,
  canShowHrmPerformanceMenuForEmployee,
  canShowHrmSingleMenuForEmployee,
  canShowHrmTicketsMenuForEmployee,
  canShowHrmTrainingMenuForEmployee,
  isHrmAttendanceMenuValue,
  isHrmEmployeeMenuValue,
  isHrmEmployeesParentMenu,
  isHrmPayrollMenuValue,
  isHrmPayrollCompanySettingsMenu,
  isHrmMyPayrollMenu,
  isHrmEmployeeDocumentsMenu,
  isHrmPayrollParentMenu,
  isHrmPerformanceMenuValue,
  isHrmSingleMenuValue,
  isHrmTicketsMenuValue,
  isHrmTrainingMenuValue,
} from "@/utils/hrmAccess";

export default {
  name: "SidebarMenu",

  data() {
    return {
      sideBarData,
      openMenuItem: null,
      openSubmenuOneItem: null,
      multilevel: [false, false, false],
      lockedModalTitle: "Upgrade to unlock this area",
      lockedModalMessage:
        "This area is not included in your current plan. Upgrade or renew billing to continue.",
      lockedModalContext: "billing",
    };
  },

  setup() {
    const authStore = useAuthStore();
    const accessStore = useAccessStore();

    return { authStore, accessStore };
  },

  computed: {
    // ----- ROLE HELPERS -----
    currentRoles() {
      return this.authStore.user?.roles || [];
    },
    isSuperAdmin() {
      return this.currentRoles.includes("SuperAdmin");
    },
    isAdmin() {
      return this.currentRoles.includes("Admin");
    },
    isHr() {
      // support both "Hr" and "HR" just in case
      return (
        this.currentRoles.includes("Hr") || this.currentRoles.includes("HR")
      );
    },
    isEmployeeRole() {
      return this.currentRoles.includes("Employee");
    },
    isClientRole() {
      return this.currentRoles.includes("Client");
    },
    // Employee who is NOT also Admin / HR / SuperAdmin
    isPureEmployee() {
      return (
        this.isEmployeeRole && !this.isAdmin && !this.isHr && !this.isSuperAdmin
      );
    },
    isLineManager() {
      return !!this.authStore.user?.is_line_manager;
    },
    isPureClient() {
      return (
        this.isClientRole &&
        !this.isEmployeeRole &&
        !this.isAdmin &&
        !this.isHr &&
        !this.isSuperAdmin
      );
    },

    activeCompanyId() {
      return getActiveCompanyId();
    },
    hasTenantContext() {
      return isTenancyFrontendEnabled() && isTenantHost();
    },
    isSuperAdminWithoutCompany() {
      return this.isSuperAdmin && !this.activeCompanyId;
    },
    planModules() {
      return this.accessStore.modules || [];
    },

    // the flat items for SuperAdmin without company
    superAdminRootMenus() {
      const main = this.sideBarData.find((s) => s.tittle === "Main Menu");
      if (!main) return [];

      const superAdminMenu = (main.menu || []).find(
        (m) => m.menuValue === "Super Admin"
      );
      if (!superAdminMenu || !superAdminMenu.subMenus) return [];

      const allowedLabels = [
        "Dashboard",
        "Companies",
        "Subscriptions",
        "Packages",
        "Purchase Transaction",
        "Demo Requests",
        "Migration Center",
      ];

      return superAdminMenu.subMenus.filter((sub) =>
        allowedLabels.includes(sub.menuValue)
      );
    },

    isMenuActive() {
      return (menu) => {
        return (
          this.$route.path === menu.route ||
          this.$route.path === menu.active_link ||
          this.$route.path === menu.active_link1 ||
          this.$route.path === menu.active_link2 ||
          this.$route.path === menu.active_link3 ||
          this.$route.path === menu.active_link4 ||
          this.$route.path === menu.active_link5
        );
      };
    },

    isActive() {
      return (menu) => {
        const result = this.$route.path.split("/").filter((part) => part);
        const base = result[0];
        return base === menu.active_link || base === menu.active_link1;
      };
    },

    isSubActive() {
      return (menu) => {
        const result = this.$route.path.split("/").filter((part) => part);
        const base = result[0];
        return base === menu.active_link;
      };
    },
  },

  methods: {
    /** ===== ACCESS / MODULE & LOCK HELPERS ===== **/

    hasPermission(permission) {
      if (typeof this.authStore?.can === "function") {
        return !!this.authStore.can(permission);
      }

      return Array.isArray(this.authStore?.permissions)
        ? this.authStore.permissions.includes(permission)
        : false;
    },

    // legacy helper (no longer used for hiding; kept in case you re-use it elsewhere)
    hasModuleKey(key) {
      if (!key) return true;
      if (!this.activeCompanyId) return false;
      if (this.isSuperAdmin) return true;
      if (this.accessStore.fullAccess) return true;
      return this.planModules.includes(key);
    },

    getModuleKey(parent, item) {
      if (item && item.moduleKey) return item.moduleKey;
      if (parent && parent.moduleKey) return parent.moduleKey;
      return null;
    },

    // isLockedKey(key) {
    //   // no module key → always unlocked
    //   if (!key) return false;

    //   // no company selected → treat as unlocked (we're in company context here anyway)
    //   // if (!this.activeCompanyId) return false;
    //   // ✅ safe default
    //   if (!this.activeCompanyId) {
    //     // SuperAdmin without company is handled by your special-case template,
    //     // but for normal users: no company context should NEVER unlock modules
    //     return !this.isSuperAdmin;
    //   }

    //   // SuperAdmin in company context → never locked
    //   if (this.isSuperAdmin) return false;

    //   const status = this.accessStore.status;

    //   // trial ended / subscription ended / no subscription
    //   if (status === "expired" || status === "none") return true;

    //   // active or trialing but module not in plan → locked
    //   return !this.planModules.includes(key);
    // },

    isLockedKey(key) {
      if (!key) return false;

      // ✅ If no active company:
      // - SuperAdmin without company: sidebar is already in special mode, so don't lock
      // - Normal users: lock to prevent accidental "free access" UI
      // On tenant subdomains the company is resolved from the host — no header needed.
      if (!this.activeCompanyId && !this.hasTenantContext) {
        return !this.isSuperAdmin;
      }

      // SuperAdmin in company context → never locked
      if (this.isSuperAdmin) return false;
      if (this.accessStore.fullAccess) return false;

      const status = this.accessStore.status;

      if (["expired", "none", "locked", "suspended", "inactive"].includes(status)) return true;

      return !this.planModules.includes(key);
    },

    /** Whether the module key is included in the active company plan. */
    isModuleInPlan(key) {
      if (!key) return true;
      if (this.isSuperAdmin) return true;
      if (this.accessStore.fullAccess) return true;

      if (!this.activeCompanyId && !this.hasTenantContext) {
        return false;
      }

      const status = this.accessStore.status;
      if (["expired", "none", "locked", "suspended", "inactive"].includes(status)) {
        return false;
      }

      return this.planModules.includes(key);
    },

    /** Pure employees should not see plan-excluded modules (admins see them as locked). */
    shouldHideForEmployeePlan(parent, item) {
      if (!this.isPureEmployee) return false;

      const key = this.getModuleKey(parent, item);
      if (!key) return false;

      return !this.isModuleInPlan(key);
    },

    menuHasVisibleSubmenus(menu) {
      return (menu.subMenus || []).some((sub) => {
        if (!this.shouldShowSub(menu, sub)) return false;

        if (sub.customSubmenuTwo && Array.isArray(sub.subMenusTwo)) {
          return sub.subMenusTwo.some((subTwo) =>
            this.shouldShowSubTwo(menu, sub, subTwo),
          );
        }

        return true;
      });
    },

    lockMessageForKey(key) {
      if (!this.isLockedKey(key)) return "";

      const status = this.accessStore.status;
      if (this.accessStore.isModuleDisabledByCompany?.(key)) {
        return "Contact system administrator for access.";
      }
      if (status === "locked") {
        return "Annual license renewal is required to restore access.";
      }
      if (["expired", "none", "suspended", "inactive"].includes(status)) {
        return "Subscription expired. Renew to unlock.";
      }
      return "Not included in your current plan. Upgrade to unlock.";
    },

    isMenuLocked(menu) {
      const key = this.getModuleKey(null, menu);
      return this.isLockedKey(key);
    },

    isSubMenuLocked(parent, sub) {
      const key = this.getModuleKey(parent, sub);
      return this.isLockedKey(key);
    },

    lockMessageForMenu(menu) {
      const key = this.getModuleKey(null, menu);
      return this.lockMessageForKey(key);
    },

    lockMessageForSub(parent, sub) {
      const key = this.getModuleKey(parent, sub);
      return this.lockMessageForKey(key);
    },

    onLockedClick(message, menuName) {
      const adminDisabled = String(message || "").includes("disabled for your company by the system administrator");
      this.lockedModalContext = adminDisabled ? "admin" : "billing";
      this.lockedModalTitle = adminDisabled
        ? (menuName ? `${menuName} is disabled` : "Disabled by your administrator")
        : menuName
        ? `Unlock ${menuName}`
        : "Upgrade to unlock this area";
      this.lockedModalMessage = message || "This area is not included in your current plan. Upgrade or renew billing to continue.";

      const el = document.getElementById("plan_upgrade_modal");
      if (el) {
        bootstrap.Modal.getOrCreateInstance(el).show();
      }
    },

    navigateToBilling() {
      const el = document.getElementById("plan_upgrade_modal");
      if (el) {
        bootstrap.Modal.getOrCreateInstance(el).hide();
      }

      if (this.$route.path !== "/billing") {
        this.$router.push("/billing");
      }
    },

    /** ===== ROLE-BASED VISIBILITY ===== **/

    // Top-level menu (Dashboard, Applications, Employee, Sales, etc.)
    shouldShowMenu(menu) {
      // Super Admin block is already handled here
      if (menu.menuValue === "Super Admin" && !this.isSuperAdmin) {
        return false;
      }

      if (menu.menuValue === "Billing") {
        return this.isAdmin;
      }

      // For SuperAdmin / Admin / HR → keep everything (except Super Admin check above)
      if (!this.isPureEmployee && !this.isPureClient) {
        // My Payroll is employee self-service — hide for Admin/HR when nothing to show
        if (isHrmMyPayrollMenu(menu.menuValue)) {
          const subs = menu.subMenus || [];
          return subs.some((sub) => this.shouldShowSub(menu, sub));
        }
        if (isHrmEmployeeDocumentsMenu(menu.menuValue)) {
          return false;
        }
        return true;
      }

      if (this.isPureClient) {
        const name = menu.menuValue;
        const visibleMenus = [];

        if (this.hasPermission("Client.Read")) visibleMenus.push("Clients");
        if (this.hasPermission("Contact.Read")) visibleMenus.push("Contacts");
        if (this.hasPermission("Project.Read") || this.hasPermission("Task.Read")) {
          visibleMenus.push("Projects");
        }
        if (this.hasPermission("Invoice.Read") || this.hasPermission("Payment.Read")) {
          visibleMenus.push("Sales");
        }

        return visibleMenus.includes(name);
      }

      // PURE EMPLOYEE VISIBILITY RULES
      const name = menu.menuValue;

      if (isHrmEmployeeDocumentsMenu(name)) {
        if (this.shouldHideForEmployeePlan(null, menu)) {
          return false;
        }
        return true;
      }

      // CRM: visible when the employee has the matching permission and plan includes the module.
      if (isCrmMenuValue(name)) {
        if (!canShowCrmMenuForEmployee(name, (p) => this.hasPermission(p))) {
          return false;
        }
        if (this.shouldHideForEmployeePlan(null, menu)) {
          return false;
        }
        return true;
      }

      if (isFinanceSalesMenuValue(name) || name === "Sales") {
        if (name !== "Sales" && !canShowFinanceSalesMenuForEmployee(name, (p) => this.hasPermission(p))) {
          return false;
        }
        if (name === "Sales") {
          const subs = menu.subMenus || [];
          const anyVisible = subs.some((sub) =>
            canShowFinanceSalesMenuForEmployee(sub.menuValue, (p) =>
              this.hasPermission(p),
            ),
          );
          if (!anyVisible) return false;
        }
        if (this.shouldHideForEmployeePlan(null, menu)) {
          return false;
        }
        return true;
      }

      if (isFinanceAccountingMenuValue(name) || name === "Accounting") {
        if (name !== "Accounting" && !canShowFinanceAccountingMenuForEmployee(name, (p) => this.hasPermission(p))) {
          return false;
        }
        if (name === "Accounting") {
          const subs = menu.subMenus || [];
          const anyVisible = subs.some((sub) =>
            canShowFinanceAccountingMenuForEmployee(sub.menuValue, (p) =>
              this.hasPermission(p),
            ),
          );
          if (!anyVisible) return false;
        }
        if (this.shouldHideForEmployeePlan(null, menu)) {
          return false;
        }
        return true;
      }

      if (isAdminAssetsMenuValue(name) || name === "Assets") {
        if (name !== "Assets" && !canShowAdminAssetsMenuForEmployee(name, (p) => this.hasPermission(p))) {
          return false;
        }
        if (name === "Assets") {
          const subs = menu.subMenus || [];
          const anyVisible = subs.some((sub) =>
            canShowAdminAssetsMenuForEmployee(sub.menuValue, (p) =>
              this.hasPermission(p),
            ),
          );
          if (!anyVisible) return false;
        }
        if (this.shouldHideForEmployeePlan(null, menu)) {
          return false;
        }
        return true;
      }

      if (isAdminSettingsMenuValue(name) || name === "User Management" || name === "Settings") {
        if (
          name !== "User Management" &&
          name !== "Settings" &&
          !canShowAdminSettingsMenuForEmployee(name, (p) => this.hasPermission(p))
        ) {
          return false;
        }
        if (name === "User Management") {
          const subs = menu.subMenus || [];
          const anyVisible = subs.some((sub) =>
            canShowAdminSettingsMenuForEmployee(sub.menuValue, (p) =>
              this.hasPermission(p),
            ),
          );
          if (!anyVisible) return false;
        }
        if (name === "Settings") {
          const subs = menu.subMenus || [];
          const anyVisible = subs.some((sub) =>
            this.menuHasVisibleSubmenus(menu),
          );
          if (!anyVisible) return false;
        }
        if (this.shouldHideForEmployeePlan(null, menu)) {
          return false;
        }
        return true;
      }

      if (isAdminReportsMenuValue(name) || name === "Reports") {
        if (name !== "Reports" && !canShowAdminReportsMenuForEmployee(name, (p) => this.hasPermission(p))) {
          return false;
        }
        if (name === "Reports") {
          const subs = menu.subMenus || [];
          const anyVisible = subs.some((sub) =>
            this.menuHasVisibleSubmenus(menu),
          );
          if (!anyVisible) return false;
        }
        if (this.shouldHideForEmployeePlan(null, menu)) {
          return false;
        }
        return true;
      }

      if (isHrmEmployeeMenuValue(name) || isHrmEmployeesParentMenu(name)) {
        if (
          !isHrmEmployeesParentMenu(name) &&
          !canShowHrmEmployeeMenuForEmployee(name, (p) => this.hasPermission(p))
        ) {
          return false;
        }
        if (isHrmEmployeesParentMenu(name)) {
          const subs = menu.subMenus || [];
          const anyVisible = subs.some((sub) =>
            canShowHrmEmployeeMenuForEmployee(sub.menuValue, (p) =>
              this.hasPermission(p),
            ),
          );
          if (!anyVisible) return false;
        }
        if (this.shouldHideForEmployeePlan(null, menu)) {
          return false;
        }
        return true;
      }

      if (isHrmPayrollMenuValue(name) || isHrmPayrollParentMenu(name)) {
        if (!isHrmPayrollParentMenu(name) && !canShowHrmPayrollMenuForEmployee(name, (p) => this.hasPermission(p))) {
          return false;
        }
        if (isHrmPayrollParentMenu(name)) {
          const subs = menu.subMenus || [];
          const anyVisible = subs.some((sub) =>
            this.shouldShowSub(menu, sub),
          );
          if (!anyVisible) return false;
        }
        if (this.shouldHideForEmployeePlan(null, menu)) {
          return false;
        }
        return true;
      }

      if (isHrmAttendanceMenuValue(name) || name === "Attendance") {
        const canShowAttendance = this.isPureEmployee
          ? (menuValue, hasPermission) =>
              canShowHrmAttendanceMenuForPureEmployee(menuValue, hasPermission, {
                isLineManager: this.isLineManager,
              })
          : canShowHrmAttendanceMenuForEmployee;
        if (name !== "Attendance" && !canShowAttendance(name, (p) => this.hasPermission(p))) {
          return false;
        }
        if (name === "Attendance") {
          const anyVisible = this.menuHasVisibleSubmenus(menu);
          if (!anyVisible) return false;
        }
        if (this.shouldHideForEmployeePlan(null, menu)) {
          return false;
        }
        return true;
      }

      if (isHrmPerformanceMenuValue(name) || name === "Performance") {
        if (name !== "Performance" && !canShowHrmPerformanceMenuForEmployee(name, (p) => this.hasPermission(p))) {
          return false;
        }
        if (name === "Performance") {
          const subs = menu.subMenus || [];
          const anyVisible = subs.some((sub) =>
            canShowHrmPerformanceMenuForEmployee(sub.menuValue, (p) =>
              this.hasPermission(p),
            ),
          );
          if (!anyVisible) return false;
        }
        if (this.shouldHideForEmployeePlan(null, menu)) {
          return false;
        }
        return true;
      }

      if (isHrmTrainingMenuValue(name) || name === "Training") {
        if (name !== "Training" && !canShowHrmTrainingMenuForEmployee(name, (p) => this.hasPermission(p))) {
          return false;
        }
        if (name === "Training") {
          const subs = menu.subMenus || [];
          const anyVisible = subs.some((sub) =>
            canShowHrmTrainingMenuForEmployee(sub.menuValue, (p) =>
              this.hasPermission(p),
            ),
          );
          if (!anyVisible) return false;
        }
        if (this.shouldHideForEmployeePlan(null, menu)) {
          return false;
        }
        return true;
      }

      if (isHrmTicketsMenuValue(name) || name === "Tickets") {
        if (name !== "Tickets" && !canShowHrmTicketsMenuForEmployee(name, (p) => this.hasPermission(p))) {
          return false;
        }
        if (this.shouldHideForEmployeePlan(null, menu)) {
          return false;
        }
        return true;
      }

      if (isHrmSingleMenuValue(name)) {
        if (!canShowHrmSingleMenuForEmployee(name, (p) => this.hasPermission(p))) {
          return false;
        }
        if (this.shouldHideForEmployeePlan(null, menu)) {
          return false;
        }
        return true;
      }

      // Hide full admin / configuration areas for employees
      const denyForEmployee = [
        // Administration (permission-gated menus handled above)
        "Help & Supports",
        "Billing",
        // Super Admin menu (extra guard)
        "Super Admin",
      ];

      if (denyForEmployee.includes(name)) {
        return false;
      }

      // The ones we DO want pure employees to see (when included in their plan):
      // - Dashboard
      // - Applications
      // - HRM: Tickets, Holidays, Attendance, Performance, Training
      // - Projects (only if plan includes project modules)
      if (menu.hasSubRoute || menu.hasSubRouteTwo) {
        return this.menuHasVisibleSubmenus(menu);
      }

      if (this.shouldHideForEmployeePlan(null, menu)) {
        return false;
      }

      return true;
    },

    // Submenu (inside Dashboard, Attendance, etc.)
    shouldShowSub(parentMenu, subMenu) {
      if (this.shouldHideForEmployeePlan(parentMenu, subMenu)) {
        return false;
      }

      const parent = parentMenu.menuValue;
      const name = subMenu.menuValue;

      if (this.isPureClient) {
        if (parent === "Projects") {
          return (
            (name === "Projects" && this.hasPermission("Project.Read")) ||
            ((name === "Tasks" || name === "Task Board") &&
              this.hasPermission("Task.Read"))
          );
        }

        if (parent === "Sales") {
          return (
            (name === "Invoices" && this.hasPermission("Invoice.Read")) ||
            (name === "Payments" && this.hasPermission("Payment.Read"))
          );
        }

        return true;
      }

      if (parent === "Sales" && this.isPureEmployee) {
        return canShowFinanceSalesMenuForEmployee(name, (p) =>
          this.hasPermission(p),
        );
      }

      if (parent === "Accounting" && this.isPureEmployee) {
        return canShowFinanceAccountingMenuForEmployee(name, (p) =>
          this.hasPermission(p),
        );
      }

      if (parent === "Assets" && this.isPureEmployee) {
        return canShowAdminAssetsMenuForEmployee(name, (p) =>
          this.hasPermission(p),
        );
      }

      if (parent === "User Management" && this.isPureEmployee) {
        return canShowAdminSettingsMenuForEmployee(name, (p) =>
          this.hasPermission(p),
        );
      }

      if (
        (parent === "General Settings" ||
          parent === "System Settings" ||
          parent === "Other Settings") &&
        this.isPureEmployee
      ) {
        return canShowAdminSettingsMenuForEmployee(name, (p) =>
          this.hasPermission(p),
        );
      }

      if (parent === "Reports" && this.isPureEmployee) {
        return canShowAdminReportsMenuForEmployee(name, (p) =>
          this.hasPermission(p),
        );
      }

      if (parent === "Settings" && this.isPureEmployee) {
        return canShowAdminSettingsMenuForEmployee(name, (p) =>
          this.hasPermission(p),
        );
      }

      if (isHrmEmployeesParentMenu(parent) && this.isPureEmployee) {
        return canShowHrmEmployeeMenuForEmployee(name, (p) =>
          this.hasPermission(p),
        );
      }

      if (isHrmPayrollCompanySettingsMenu(parent) && this.isPureEmployee) {
        return false;
      }

      if (isHrmMyPayrollMenu(parent)) {
        if (name === "My Payslips" || name === "My P9") {
          if (this.isPureEmployee) {
            return (
              this.hasPermission("Payroll.ReadSelf") ||
              this.hasPermission("Payroll.Read")
            );
          }
          if (this.isSuperAdmin) return true;
          return false;
        }
        return false;
      }

      if (isHrmPayrollCompanySettingsMenu(parent)) {
        return (
          this.isSuperAdmin ||
          this.isAdmin ||
          this.isHr ||
          this.hasPermission("Payroll.Read") ||
          this.hasPermission("Payroll.Create") ||
          this.hasPermission("Payroll.Edit") ||
          this.hasPermission("Payroll.Approve")
        );
      }

      if (
        (parent === "Leaves" ||
          parent === "Attendance" ||
          name === "Attendance (Admin)" ||
          name === "Attendance (Employee)" ||
          name === "Timesheets" ||
          name === "My Timesheets" ||
          name === "My Schedule" ||
          name === "Shift & Schedule" ||
          name === "Payroll Overtime") &&
        this.isPureEmployee
      ) {
        return canShowHrmAttendanceMenuForPureEmployee(name, (p) =>
          this.hasPermission(p),
          { isLineManager: this.isLineManager },
        );
      }

      if (parent === "Performance" && this.isPureEmployee) {
        return canShowHrmPerformanceMenuForEmployee(name, (p) =>
          this.hasPermission(p),
        );
      }

      if (parent === "Training" && this.isPureEmployee) {
        return canShowHrmTrainingMenuForEmployee(name, (p) =>
          this.hasPermission(p),
        );
      }

      // ===== PURE EMPLOYEE-SPECIFIC RULES =====

      if (parent === "Tickets" && this.isPureEmployee) {
        return canShowHrmTicketsMenuForEmployee(name, (p) =>
          this.hasPermission(p),
        );
      }

      // ===== GLOBAL RULES (apply before role-specific branches) =====

      // Applications → Invoices: hidden for pure employees
      if (
        parent === "Applications" &&
        name === "Invoices" &&
        this.isPureEmployee
      ) {
        return false;
      }

      // Dashboard → Employee Dashboard
      // - pure employee: YES
      // - SuperAdmin: YES (optional, for debugging)
      // - Admin / HR: NO
      if (parent === "Dashboard" && name === "Employee Dashboard") {
        if (this.isPureEmployee) return true;
        // if (this.isSuperAdmin) return true; // remove if you also want to hide from SuperAdmin
        return false; // Admin / HR can't see Employee Dashboard
      }

      // Attendance (Employee): only pure Employee OR SuperAdmin
      if (parent === "Attendance" && name === "Attendance (Employee)") {
        return this.isPureEmployee || this.isSuperAdmin;
      }

      // Attendance (Admin) is not for pure employees.
      if (parent === "Attendance" && name === "Attendance (Admin)") {
        return !this.isPureEmployee;
      }
      // Timesheets stay visible for employees; the route redirects them to their self-service page.
      if (parent === "Attendance" && name === "Timesheets") {
        return !this.isPureEmployee;
      }
      if (parent === "Attendance" && name === "My Timesheets") {
        return this.isPureEmployee || this.isSuperAdmin;
      }
      if (parent === "Attendance" && name === "My Schedule") {
        return this.isPureEmployee || this.isSuperAdmin;
      }
      // Shift & Schedule stays admin-side.
      if (parent === "Attendance" && name === "Shift & Schedule") {
        return !this.isPureEmployee;
      }
      if (parent === "Attendance" && name === "Payroll Overtime") {
        return !this.isPureEmployee;
      }

      // Leaves (LEVEL-2 menu) itself is visible to everyone;
      // its children are filtered in shouldShowSubTwo.
      if (parent === "Attendance" && name === "Leaves") {
        return true;
      }

      // ===== PURE EMPLOYEE-SPECIFIC RULES =====
      if (this.isPureEmployee) {
        // Dashboard:
        // Employee Dashboard already handled above.
        // Admin / Deals / Leads dashboards should be hidden to employees.
        if (parent === "Dashboard") {
          // Only Admin / Deals / Leads dashboards left here -> hide for employees
          return false;
        }

        // Attendance: specific entries handled above; others OK
        if (parent === "Attendance") {
          return true;
        }

        // Performance: show only personal record lists to pure employees.
        if (parent === "Performance") {
          return (
            name === "Performance Review List" ||
            name === "Performance Appraisal"
          );
        }

        // Training: show only the employee's own training list.
        if (parent === "Training") {
          return name === "Training List";
        }

        // Other parents (Tickets, Holidays, Performance, Training, Projects, Applications)
        // → show all their submenus, except where explicitly blocked above
        return true;
      }

      // ===== Non-pure employees (Admin, HR, SuperAdmin) =====
      // also covers pure clients after their explicit branch above
      // Other than special cases above, show all submenus.
      return true;
    },

    // Third level: items in subMenus.subMenusTwo (e.g. Leaves → Leaves (Admin) / Leave (Employee) / Leave Settings)

    shouldShowSubTwo(parentMenu, subMenus, subMenuTwo) {
      if (this.shouldHideForEmployeePlan(subMenus, subMenuTwo)) {
        return false;
      }

      const parent = parentMenu.menuValue;
      const level2 = subMenus.menuValue;
      const name = subMenuTwo.menuValue;

      // Report items tied to Enterprise modules (Sales / Projects) — hide on Basic.
      if (
        parent === "Reports" &&
        subMenuTwo.moduleKey &&
        !this.isSuperAdmin &&
        !this.isModuleInPlan(subMenuTwo.moduleKey)
      ) {
        return false;
      }

      if (this.isPureClient) {
        return false;
      }

      // Only Attendance → Leaves has third-level items
      if (parent === "Attendance" && level2 === "Leaves") {
        if (name === "Leave (Employee)") {
          return this.isPureEmployee || this.isSuperAdmin;
        }

        if (name === "Leaves (Admin)" || name === "Leave Settings") {
          return this.isAdmin || this.isHr || this.isSuperAdmin || (name === "Leaves (Admin)" && this.isLineManager);
        }

        if (this.isPureEmployee) {
          return canShowHrmAttendanceMenuForPureEmployee(name, (p) =>
            this.hasPermission(p),
            { isLineManager: this.isLineManager },
          );
        }
      }

      if (parent === "Reports" && this.isPureEmployee) {
        return canShowAdminReportsMenuForEmployee(name, (p) =>
          this.hasPermission(p),
        );
      }

      if (parent === "Settings" && this.isPureEmployee) {
        return canShowAdminSettingsMenuForEmployee(name, (p) =>
          this.hasPermission(p),
        );
      }

      if (isHrmEmployeesParentMenu(parent)) {
        return canShowHrmEmployeeMenuForEmployee(name, (p) =>
          this.hasPermission(p),
        );
      }

      // Everyone else: default visible
      return true;
    },

    // Decide if the whole section (HRM, Finance & Accounts, etc.) should appear
    shouldShowSection(section) {
      return (section.menu || []).some((m) => this.shouldShowMenu(m));
    },

    /** ===== TOGGLING (unchanged) ===== **/

    expandSubMenus(menu) {
      this.sideBarData.forEach((item) => {
        (item.menu || []).forEach((subMenu) => {
          if (subMenu !== menu) {
            subMenu.showSubRoute = false;
          }
        });
      });
      menu.showSubRoute = !menu.showSubRoute;
    },

    OpenMenu(menu) {
      this.sideBarData.forEach((item) => {
        (item.menu || []).forEach((subMenu) => {
          subMenu.showSubRoute = false;
        });
      });
      this.openMenuItem = this.openMenuItem === menu ? null : menu;
    },

    openSubmenuOne(subMenus) {
      this.openSubmenuOneItem =
        this.openSubmenuOneItem === subMenus ? null : subMenus;
    },
  },
};
</script>

<style scoped>
.menu-locked > a,
.menu-locked a {
  opacity: 0.5;
  cursor: not-allowed;
}

.menu-locked i {
  opacity: 0.6;
}

.menu-title {
  cursor: default;
}

.menu-title span {
  pointer-events: none; /* ensure it can't act like a link */
}
</style>
